module.exports = __webpack_public_path__ + "static/media/events.35b20ef4.graphql";